import { render } from "./createInstructionForm.vue?vue&type=template&id=47f6f5ed&ts=true"
import script from "./createInstructionForm.vue?vue&type=script&lang=ts"
export * from "./createInstructionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__